import React from 'react';
import './Hero.css';

const Hero = () => {

    return (
        <section id="home" className="hero-section">
            <div className="hero-container">
                {/* Left Side - Content */}
                <div className="hero-content">
                    <div className="hero-badge">
                        <span>Assistant Professor & Researcher</span>
                    </div>

                    <h1 className="hero-title">
                        Pawan Kumar
                        <span className="title-underline"></span>
                    </h1>

                    <p className="hero-description">
                        Dedicated educator and researcher with 8+ years of experience in management education,
                        specializing in Marketing, HR, and AI applications. Currently contributing to academic
                        excellence at Pimpri Chinchwad University, Pune.
                    </p>

                    {/* Quick Stats */}
                    <div className="quick-stats">
                        <div className="stat-item">
                            <span className="stat-number">8+</span>
                            <span className="stat-label">Years Exp</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-number">15+</span>
                            <span className="stat-label">Publications</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-number">10+</span>
                            <span className="stat-label">FDPs Attended</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-number">1</span>
                            <span className="stat-label">Patent</span>
                        </div>
                    </div>
                </div>

                {/* Right Side - Profile & Facts */}
                <div className="hero-visual">
                    {/* Profile Photo */}
                    <div className="profile-photo-container">
                        <div className="profile-photo">
                            <div className="photo-placeholder">
                                {/* Add your image here */}
                                <img
                                    src="/assets/profile.jpg"
                                    alt="Pawan Kumar Singh"
                                    className="profile-image"
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.nextElementSibling.style.display = 'flex';
                                    }}
                                />
                                {/* Fallback initials if image fails to load */}
                                <span className="photo-initials">PK</span>
                            </div>
                            <div className="photo-frame"></div>
                            <div className="photo-badge">
                                <span>8+ Years Exp</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    );
};

export default Hero;